<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html,body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

  body {
    font-family: 'Nunito', sans-serif;
    /*background-color: rgba(0,0,0,0); background-color: #F9FAFB;*/
  }

  .is-horizontal-center {
    justify-content: center;
  }

  .loading-overlay .loading-background {
    background: hsla(170, 75.6%, 40.2%, 0.5) !important;
  }

  /*@supports(padding: max(0px)) {
    .is-safe-area-X {
        padding-left: max(12px, env(safe-area-inset-left));
        padding-right: max(12px, env(safe-area-inset-right));
        padding-left: max(12px, constant(safe-area-inset-left));
        padding-right: max(12px, constant(safe-area-inset-right));
    }
  }*/
  @media only screen and (max-width: 768px) {
    .modal-close {
      background-color: rgba(25, 180, 155, 0.8);
      right: 50%;
      margin-right: -16px;
    }
  }

  .Cookie--giada {
    background-color: rgba(35, 39, 47, 0.8);
    color: #F1F3F6;
    padding: 1.250rem 18rem;
  }

  @media only screen and (max-width: 768px) {
    .Cookie--giada {
      padding: 1.250rem;
      text-align: center;
    }
  }

  @media only screen and (max-height: 375px) {
    .Cookie--giada {
      padding: 1.250rem;
      text-align: center;
    }
  }

  .Cookie--giada .Cookie__content {
    margin: 0;
  }

  .Cookie--giada .Cookie__content a {
    color: #91949B;
  }

  .Cookie--giada  .Cookie__button {
    background: #19B49B;
    padding: calc(0.375em - 1px) 1em;
    font-size: 1rem;
    color: #FFFFFF;
    border-radius: 290486px;
    text-align: center;
    white-space: nowrap;
    margin: 0;
  }

  .Cookie--giada  .Cookie__button:hover {
    background: #17a991;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue